import { Text } from '../../../../../../UILibrary';

export const MiniSelectionView = ({
  imgSrc,
  category,
  name,
  manufacturer,
}: {
  imgSrc?: string;
  category?: string;
  name?: string;
  manufacturer?: string;
}) => {
  return (
    <div className="flex items-center gap-4 h-[72px]">
      {imgSrc ? (
        <img
          className="min-w-[72px] w-[72px] h-[72px] rounded-md brightness-95"
          src={`${imgSrc}?width=72&height=72`}
          alt="Selected Product"
        />
      ) : (
        <div className="min-w-[72px] w-[72px] h-[72px] rounded-md bg-[#F5F5F7]" />
      )}

      <div className="flex flex-col">
        {category && (
          <Text variant="Caption3" className="uppercase text-[#86868B]">
            {category}
          </Text>
        )}
        {name && <Text variant="Title5">{name}</Text>}
        {manufacturer && <Text variant="Caption2">{manufacturer}</Text>}
      </div>
    </div>
  );
};
